import { z } from "zod";

const BrowseRisksSummarySchema = z.object({
  query: z.any(),
});

export default BrowseRisksSummarySchema;
